import React from 'react';

export const LoaderBars = () => (
  <div className="axiom-loader-bars">
    <div className="line" />
    <div className="line" />
    <div className="line" />
  </div>
);
